import styled, { css } from 'styled-components'
import { getBreakPoint } from '../../../../lib/styles/breakpoints'
import CustomLink from '../../../../components/CustomLink'
import { RecommendedArticleItemContentWrapperBaseStyle, RecommendedArticleWrapperBaseStyle } from '../styled'
import { RecommendedArticleAssetComponentProps } from '../../types'

export const CustomerStoriesMediaWrapper = styled.picture<RecommendedArticleAssetComponentProps>`
  height: ${({ $isSmall }) => ($isSmall ? '1.5rem' : '2rem')};
  width: ${({ $isSmall }) => ($isSmall ? '5.2rem' : '7rem')};
  @media (${getBreakPoint('sm')}) {
    ${({ $isSmall }) =>
      !$isSmall &&
      css`
        height: 2rem;
        width: 8rem;
        align-self: flex-start;
      `};
  }
`
export const StyledArticleContentSeparator = styled.div`
  display: none;
  @media (${getBreakPoint('md', 'min')}) {
    display: block;
    &::after {
      content: '';
      position: absolute;
      border-right-width: 1px;
      border-right-style: solid;
      border-right-color: ${({ theme }) => theme.colors.black[5]};
      height: calc(100% - 4rem);
      top: 2rem;
    }
  }
`
export const CustomerStoriesMedia = styled.img<RecommendedArticleAssetComponentProps>`
  height: 100%;
  width: auto;
  object-fit: contain;
  margin: auto;

  @media (${getBreakPoint('sm')}) {
    margin: ${({ $isSmall }) => !$isSmall && 'unset'};
  }
`

export const CustomerStoriesComponentWrapper = styled(CustomLink)<RecommendedArticleAssetComponentProps>`
  ${RecommendedArticleWrapperBaseStyle};
  padding: ${({ $isSmall }) => ($isSmall ? '1rem 1.5rem 1rem 1rem' : '2rem 1.5rem')};
  min-height: ${({ $isSmall }) => ($isSmall ? 'unset' : '6rem')};
  gap: 1.5rem;
  border: 1px solid ${({ theme }) => theme.colors.black[1]};
  background-color: ${({ theme }) => theme.colors.white[1]};
  &:hover {
    background-color: ${({ theme }) => theme.colors.black[7]};
  }
  &:hover,
  &:focus-visible {
    border-color: transparent;
  }
`

export const CustomerStoriesContentWrapper = styled.div`
  ${RecommendedArticleItemContentWrapperBaseStyle};
`
